import type { CustomErrorRule } from '@/core/error/transport/types'
import { TmApiTokenIsLockedError } from '@/core/error/transport/tmApiTokenIsLockedError'

export const tokenIsLockedErrorRule: CustomErrorRule = {
  subCodes: ['user.token.is_locked'],
  klass: TmApiTokenIsLockedError,
}
